import { render, staticRenderFns } from "./xjt.vue?vue&type=template&id=f831044a&scoped=true"
import script from "./xjt.vue?vue&type=script&lang=js"
export * from "./xjt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f831044a",
  null
  
)

export default component.exports